import React from 'react';
import { Link } from 'react-router-dom';
import { HeartOff, Heart } from 'lucide-react';
import { Button } from '../components/ui/button';
import BookCard from '../components/BookCard';
import { BOOKS } from '../mock/mock';
import { useFavorites } from '../context/FavoritesContext';
import { PageHero } from './BuyABook';

const Favourites = () => {
  const { ids } = useFavorites();
  const favBooks = BOOKS.filter((b) => ids.includes(b.id));

  return (
    <div className="fade-in">
      <PageHero
        title="My Shelf"
        subtitle="The books you've saved — read the free ones anytime, or order a printed copy."
      />

      <section className="max-w-7xl mx-auto px-5 lg:px-8 py-16">
        {favBooks.length === 0 ? (
          <div className="text-center py-16">
            <HeartOff className="h-14 w-14 text-brand-goldlight mx-auto mb-5" />
            <h2 className="font-serif text-2xl font-bold text-brand-ink">Your shelf is empty</h2>
            <p className="text-brand-brown/70 mt-2">
              Tap the <Heart className="inline h-4 w-4 text-brand-brass" /> heart on any book to save it here.
            </p>
            <Link to="/buy">
              <Button className="mt-6 bg-brand-gold hover:bg-brand-brass text-brand-ink hover:text-white rounded-full h-11 px-8">
                Browse Books
              </Button>
            </Link>
          </div>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-10">
            {favBooks.map((b) => (
              <BookCard key={b.id} book={b} />
            ))}
          </div>
        )}
      </section>
    </div>
  );
};

export default Favourites;
